import { render, staticRenderFns } from "./GrnCreatereturn.vue?vue&type=template&id=1f2c36b4&scoped=true"
import script from "./GrnCreatereturn.vue?vue&type=script&lang=js"
export * from "./GrnCreatereturn.vue?vue&type=script&lang=js"
import style0 from "./GrnCreatereturn.vue?vue&type=style&index=0&id=1f2c36b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2c36b4",
  null
  
)

export default component.exports